
<template>
  <div class="pt-3">
    <v-data-table
      :headers="headers"
      :items="items"
      hide-default-header
      class="elevation-0"
      dense
      item-key="time"
      :items-per-page="-1"
      mobile-breakpoint="1"
    >
      <template v-slot:header="{ props: { headers } }">
        <thead>
          <tr>
            <th 
              v-for="(h,idx) in headers" :class="h.class" :key="h.value" 
              :style="{
                borderBottom: 
                  (idx>0 && idx<headers.length-1)? 
                    `solid 3px ${ (idx>1 && idx<headers.length-2)? 'blue' : idx == 1? 'red' : '#4caf50'}` 
                  : ''
              }" 
            >
              <span
                :style="{writingMode: idx>0&&idx<headers.length-1?'sideways-lr':'', height:'150px'}" 
                :class="[h.kind? (h.kind=='P'? 'success--text' : 'red--text') : '', 'font-weight-normal text-center']"
              >
                {{h.text}}
              </span>
            </th>
          </tr>
        </thead>
      </template>
      <template v-if="false" v-slot:header.1="{ header }">
        <div class="red--text">
        {{ header.text}}
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'Model2Table',
  props: {
    headers: {
      type: Array,
    },
    items: {
      type: Array,
    },
  },
  data() {
    return {
      key: null
    }
  },
  methods: {
    names() {
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>